import { createReducer } from '@common/redux-utils';
import {
  AuthActionType,
  LoginFailureAction,
  LoginStartAction,
  LoginSuccessAction,
  LogoutFailureAction,
  LogoutStartAction,
  LogoutSuccessAction,
  TimerExpiredAction,
  TimerResetAction,
  TimerSetAction
} from './auth.actions';
import { BaseService } from '@services/BaseService';
import { ProfileViewModel } from '@models/Auth';
/*
These are the reducers for the page.
Think of these as the "event handlers" for the page.
They process business logic and update the state within the page's store
*/

export interface AuthState {
  readonly currentMessage?: string;
  readonly isLoggedIn: boolean;
  readonly isLoggingIn: boolean;
  readonly isTimerExpired: boolean;
  readonly time: string;
  readonly currentProfile: ProfileViewModel | null;
}

// This is the initial state of the reducer
const initialState: AuthState = {
  currentMessage: '',
  isLoggedIn: BaseService.hasProfile(),
  isTimerExpired: false,
  time: '00:00:00',
  isLoggingIn: false,
  currentProfile: null
};

// Reducers for each action type delcared here
// Each takes the current state, the action that caused it, and should return the new state as a result of that action
function handleLoginStart(state: AuthState, action: LoginStartAction): AuthState {
  return {
    ...state,
    isLoggingIn: true
  };
}

function handleLoginSuccess(state: AuthState, action: LoginSuccessAction): AuthState {
  localStorage.setItem('username', action.profile.email);

  return {
    ...state,
    currentMessage: '',
    isLoggedIn: true,
    isLoggingIn: false,
    currentProfile: {
      ...action.profile
    }
  };
}

function handleLoginFailure(state: AuthState, action: LoginFailureAction): AuthState {
  return {
    ...state,
    currentMessage: action.error,
    isLoggedIn: false,
    isLoggingIn: false
  };
}

function handleLogoutStart(state: AuthState, action: LogoutStartAction): AuthState {
  return {
    ...state,
    currentMessage: 'Signing out!',
    isLoggingIn: true
  };
}

function handleLogoutSuccess(state: AuthState, action: LogoutSuccessAction): AuthState {
  return {
    ...state,
    currentMessage: 'Sign out complete!',
    isLoggedIn: false,
    isLoggingIn: false,
    isTimerExpired: false,
    currentProfile: {} as ProfileViewModel
  };
}

function handleLogoutFailure(state: AuthState, action: LogoutFailureAction): AuthState {
  return {
    ...state,
    currentMessage: action.error,
    isLoggedIn: false,
    isLoggingIn: false,
    isTimerExpired: false,
    currentProfile: {} as ProfileViewModel
  };
}

function handleTimerExpired(state: AuthState, action: TimerExpiredAction): AuthState {
  return {
    ...state,
    isTimerExpired: true
  };
}

function handleTimerReset(state: AuthState, action: TimerResetAction): AuthState {
  return {
    ...state,
    isTimerExpired: false
  };
}

function handleTimerSet(state: AuthState, action: TimerSetAction): AuthState {
  return {
    ...state,
    time: action.time
  };
}

// This creates the reducer as redux wants it w/ a helper function
// There should an entry for each action type
export const AuthReducer = createReducer(initialState, {
  [AuthActionType.LoginStart]: handleLoginStart,
  [AuthActionType.LoginSuccess]: handleLoginSuccess,
  [AuthActionType.LoginFailure]: handleLoginFailure,
  [AuthActionType.LogoutStart]: handleLogoutStart,
  [AuthActionType.LogoutSuccess]: handleLogoutSuccess,
  [AuthActionType.LogoutFailure]: handleLogoutFailure,
  [AuthActionType.TimerExpired]: handleTimerExpired,
  [AuthActionType.TimerReset]: handleTimerReset,
  [AuthActionType.TimerSet]: handleTimerSet
});



// WEBPACK FOOTER //
// ./src/auth/auth.reducer.ts